import { render, staticRenderFns } from "./MovingImagesOnImageInputAnswer.vue?vue&type=template&id=40f5849d&scoped=true&"
import script from "./MovingImagesOnImageInputAnswer.vue?vue&type=script&lang=js&"
export * from "./MovingImagesOnImageInputAnswer.vue?vue&type=script&lang=js&"
import style0 from "./MovingImagesOnImageInputAnswer.vue?vue&type=style&index=0&id=40f5849d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f5849d",
  null
  
)

export default component.exports